import SaleCatalogueLink from '../components/DataTable/CatalogueLinkCell';
import ResponsiveDateCell from '../components/DataTable/ResponsiveDateCell';

const DATA_TITLE = 'data-title';

/**
 * Config for catalogues table
 */
export default {
    url: '/bloodstock/sales/catalogues/data.json',
    columns: [
        {
            displayName: 'Date',
            columnName: 'sale_date',
            headerDataAttrs: {
                [DATA_TITLE]: 'date'
            },
            customCell: {
                component: ResponsiveDateCell
            }
        },
        {
            columnName: 'sale_name',
            displayName: 'Sale',
            headerDataAttrs: {
                [DATA_TITLE]: 'sale-name'
            },
            customCell: {
                component: SaleCatalogueLink,
                options: {
                    columnUid: 'venue_uid',
                    columnDate: 'sale_raw_date',
                    columnPast: 'is_past'
                }
            }
        },
        {
            columnName: 'sale_co',
            displayName: 'Sale co',
            headerDataAttrs: {
                [DATA_TITLE]: 'sale-company'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/js/config/cataloguesTable.js